import { render } from "./Mobile.vue?vue&type=template&id=1b1a001f&scoped=true"
import script from "./Mobile.vue?vue&type=script&lang=ts"
export * from "./Mobile.vue?vue&type=script&lang=ts"

import "./Mobile.vue?vue&type=style&index=0&id=1b1a001f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b1a001f"

export default script